
<div class="modal-dialog" style="max-width: 800px;">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Select Smartsheet Workspace</h5>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body" *ngIf="loading">
      <md-spinner-block></md-spinner-block>
    </div>
    <div class="modal-body" *ngIf="!loading">
      <error [error]="error"></error>
      <div class="row" *ngIf="!token">
        <div class="col">
          <button class="btn btn-primary btn-block" (click)="logIn()">Log Into Smartsheet</button>
        </div>
      </div>
      <div class="row" *ngIf="token">
        <div class="col">
          <p><b>Please select a workspace from the list below.</b><br>You must have a Smartsheet license as well as permissions to create and manage sheets within the workspace you choose.
            TMC will create or take over two sheets named "TMC Project Data" and "TMC Site Data".
            In the future, TMC may add or take over more sheets beginning with "TMC".<br><b>All changes, including periodic data updating, will be made using your name and Smartsheet account.</b>
          </p>
          <filtered-list-controls [list]="workspaces" [showSearch]="true" [showLimit]="true"></filtered-list-controls>
          <table class="table table-sm table-responsive" *ngIf="workspaces.filteredLength">
            <thead>
              <tr>
                <th>Workspace</th>
                <th style="width: 1%"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let workspace of workspaces.filtered">
                <td>{{ workspace.name }}</td>
                <td>
                  <button class="btn btn-primary btn-sm" type="button" (click)="select(workspace)">Select</button>
                </td>
              </tr>
              <tr *ngIf="!workspaces.filteredLength">
                <td colspan="2">
                  <p class="text-center empty-table-message">You don't have necessary access to any workspaces.</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-danger" *ngIf="hasExistingIntegration" type="button" (click)="clear()">Clear</button>
      <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>